import { render, staticRenderFns } from "./goalSetting.vue?vue&type=template&id=1cd3a707&scoped=true"
import script from "./goalSetting.vue?vue&type=script&lang=js"
export * from "./goalSetting.vue?vue&type=script&lang=js"
import style0 from "./goalSetting.vue?vue&type=style&index=0&id=1cd3a707&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd3a707",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cd3a707')) {
      api.createRecord('1cd3a707', component.options)
    } else {
      api.reload('1cd3a707', component.options)
    }
    module.hot.accept("./goalSetting.vue?vue&type=template&id=1cd3a707&scoped=true", function () {
      api.rerender('1cd3a707', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/assessment/components/goalSetting.vue"
export default component.exports